import React, { HTMLAttributes, useMemo } from "react";
import { cn } from "@/helpers/classNames";

interface BoardCellProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  value: string | undefined | null;
}

const mapping: Record<string, string> = {
  128997: "#da291c",
  128999: "#ff7500",
  129000: "#ffb81c",
  129001: "#009a44",
  128998: "#0084d5",
  129002: "#702f8A",
  11036: "#fff",
};

const BoardCell: React.FC<BoardCellProps> = ({
  value,
  className,
  ...props
}) => {
  const color = useMemo<undefined | string>(() => {
    const codePoint = value?.codePointAt(0) ?? 0;

    if (!codePoint || !(codePoint in mapping)) {
      return undefined;
    }

    return mapping[codePoint] ?? " ";
  }, [value]);

  return (
    <span
      className={cn(className, "relative")}
      style={color ? { backgroundColor: color } : undefined}
      {...props}
    >
      {!color ? (
        <span className="translate-y-[0.5px]">{value?.substring(0, 1)}</span>
      ) : null}
      <span
        role="presentation"
        className="absolute inset-x-0 block border-t border-mirage/50 top-1/2 supports-p3:border-mirage-p3/50"
      />
    </span>
  );
};

export default BoardCell;
